<script>
import VueApexCharts from "vue-apexcharts";
import i18n from "@/plugins/i18n";

export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {

            chartHeight: "300px",
            series: [
                {
                    data: [0, 0, 0, 0],
                },
            ],
            chartOptions: {
                /* title: {
                    text: "KPI Progress",
                    align: 'center',
                    offsetY: 150,
                    style: {
                        fontSize: 12,
                    },
                }, */
                chart: {
                    type: "bar",
                    height: 250,
                    toolbar: {
                        show: false,
                    },
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    },
                },
                dataLabels: {
                    show: false,
                    enabled: false,
                    name: {
                        offsetY: -10,
                        show: true,
                        color: "#888",
                        fontSize: "12px",
                        fontFamily: "Muli",
                    },
                    value: {
                        formatter: function (val) {
                            return val + "%";
                        },
                        fontSize: "22px",
                        show: true,
                        color: "#037094",
                        fontFamily: "Muli",
                    },
                }, yaxis: {
                    labels: {
                        show: false,
                        style: {
                            color: "#037094",
                            fontWeight: "bold",
                            fontSize: "13px",
                            fontFamily: "Muli",
                        }
                    }
                },
                xaxis: {
                    /* tickAmount: 2,
                    range: 100, */
                    labels: {
                        show: false,
                        style: {
                            color: "#037094",
                            fontWeight: "bold",
                            fontSize: "14px",
                            fontFamily: "Muli",
                        },
                        /* formatter: function (value) {
                            return "KPI Progress";
                        }, */
                    },
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shade: "dark",
                        type: "horizontal",
                        shadeIntensity: 0.5,
                        gradientToColors: ["#023047"],
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100],
                    },
                },
                stroke: {
                    lineCap: "round",
                },
            },
        };
    },
    created() {
        this.updateChartHeight();
        window.addEventListener("resize", this.updateChartHeight);
    },
    methods: {
        updateChartHeight() {
            if (window.innerWidth < 768) {
                this.chartHeight = "50px";
            } else if (window.innerWidth < 992) {
                this.chartHeight = "110px";
            } else {
                this.chartHeight = "160px";
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateChartHeight);
    },
};
</script>

<template>
    <div id="chart">
        <apexchart type="bar" :height="chartHeight" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>
<style scoped>
#chart {
    width: 100%;
}
</style>
